
import '../WelcomeItem/WelcomeItem.scss'


const WelcomeItem = ({src,title,text,backgroundColor}) =>{
    return(
            <>
                <div className="welcome__item" style={{backgroundColor}}>
                    <div className="welcome__item-header">
                        <img className="welcome__item-header--icon" src={src} alt="icon" />
                        <p className="welcome__item-header--title">{title}</p>
                    </div>
                    <div className="welcome__item-text">{text}</div>
                </div>
            </>
    )
}


export default WelcomeItem;